module.exports = __webpack_public_path__ + "img/bank_create.430e7bec.png";